// src/components/layout/Layout.tsx
import React from 'react';
import './layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="layout-wrapper">
      {/* You can add header/sidebar here if needed */}
      <main className="layout-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;